import { useState, type JSX } from 'react';
import { Modal } from '../ui/common.js';
import { api } from '../api/client.js';
import { dateRangeError } from '../lib/validateRange.js';

/** 출장 등록 모달 — 휴가 신청 모달과 통일된 팝업 형식 */
export function TripModal({ onClose, onDone }: { onClose: () => void; onDone: (msg: string) => void }): JSX.Element {
  const today = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul' }).format(new Date());
  const [start, setStart] = useState(today);
  const [end, setEnd] = useState(today);
  const [location, setLocation] = useState('');
  const [detail, setDetail] = useState('');
  const [busy, setBusy] = useState(false);

  const rangeErr = dateRangeError(start, end);
  const canSubmit = location.trim().length > 0 && !rangeErr;

  const submit = async (): Promise<void> => {
    if (!canSubmit || busy) return;
    setBusy(true);
    try {
      await api.createTrip({ startDate: start, endDate: end, location: location.trim(), detail: detail.trim() || undefined });
      onDone('출장이 등록되었습니다 (기간 정시 출퇴근 자동 기록)');
      onClose();
    } catch (e) {
      onDone(e instanceof Error ? e.message : '등록 실패');
      setBusy(false);
    }
  };

  return (
    <Modal width={460} onClose={onClose}>
      <div style={{ padding: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 18 }}>
          <div style={{ fontSize: 17, fontWeight: 700 }}>출장 등록</div>
          <button title="닫기" onClick={onClose} style={{ border: 'none', background: 'transparent', cursor: 'pointer', color: '#6B7280', fontSize: 26, lineHeight: 1 }}>×</button>
        </div>
        <div style={{ display: 'flex', gap: 12, marginBottom: 14 }}>
          <label style={field}><span style={lbl}>시작일</span><input type="date" className="dx-input" value={start} onChange={(e) => setStart(e.target.value)} /></label>
          <label style={field}><span style={lbl}>종료일</span><input type="date" className="dx-input" value={end} onChange={(e) => setEnd(e.target.value)} /></label>
        </div>
        {rangeErr && <div style={rangeErrStyle}>{rangeErr}</div>}
        <label style={{ ...field, marginBottom: 14 }}><span style={lbl}>출장 장소</span>
          <input className="dx-input" placeholder="예: 부산 고객사" value={location} onChange={(e) => setLocation(e.target.value)} />
        </label>
        <label style={{ ...field, marginBottom: 6 }}><span style={lbl}>내역</span>
          <textarea className="dx-textarea" rows={3} placeholder="출장 목적·내용" value={detail} onChange={(e) => setDetail(e.target.value)} />
        </label>
        <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 8 }}>※ 출장 기간(평일)은 정시 출퇴근이 자동 기록됩니다.</div>
        <div style={{ display: 'flex', gap: 10, marginTop: 18 }}>
          <button className="dx-btn dx-btn-ghost" style={{ flex: 1 }} onClick={onClose}>취소</button>
          <button className="dx-btn dx-btn-primary" style={{ flex: 1 }} disabled={busy || !canSubmit} onClick={submit}>출장 등록</button>
        </div>
      </div>
    </Modal>
  );
}

const rangeErrStyle = { background: '#FEF2F2', border: '1px solid #FCA5A5', color: '#B91C1C', borderRadius: 8, padding: '8px 11px', fontSize: 12.5, fontWeight: 600, marginBottom: 14 } as const;
const field = { flex: 1, display: 'flex', flexDirection: 'column', gap: 6 } as const;
const lbl = { fontSize: 12, fontWeight: 600, color: '#6B7280' } as const;
